export default "__VITE_ASSET__CDfGZFbx__"